import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-icons',
  templateUrl: './ui-icons.component.html',
  styleUrls: ['./ui-icons.component.scss']
})
export class UiIconsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
